<script>
export default {
    props: {
        activity: {
            type: Object,
            required: true
        },
        show: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        importantInfo() {
            return this.activity?.content?.importantInfo || [];
        },
        featureGroups() {
            return this.activity?.content?.featureGroups || [];
        },
        redeemInfo() {
            return this.activity?.content?.redeemInfo;
        },
        segmentationGroups() {
            return this.activity?.content?.segmentationGroups || [];
        }
    },
    methods: {
        getFeatureTypeLabel(featureType) {
            const labels = {
                'ADMISSIONSINCL': 'Entradas incluidas',
                'MEALSINCL': 'Comidas incluidas',
                'TRANSPORTINCL': 'Transporte incluido',
                'GUIDEINCL': 'Guía incluido',
                'INSURANCEINCL': 'Seguro incluido'
            };
            return labels[featureType] || featureType;
        }
    }
};
</script>

<template>
    <div v-if="show" class="activity-details mt-3">
        <!-- Important Information -->
        <div v-if="importantInfo.length > 0" class="important-info mb-3">
            <h6 class="text-warning">
                <i class="mdi mdi-alert-circle mr-2"></i>
                Información importante
            </h6>
            <ul class="list-unstyled">
                <li 
                    v-for="(info, index) in importantInfo" 
                    :key="index"
                    class="text-muted small"
                    v-html="info"
                ></li>
            </ul>
        </div>

        <!-- Feature Groups -->
        <div v-if="featureGroups.length > 0" class="feature-groups mb-3">
            <h6 class="text-success">
                <i class="mdi mdi-check-circle mr-2"></i>
                Incluido en la actividad
            </h6>
            <div v-for="group in featureGroups" :key="group.groupCode" class="mb-2">
                <strong class="text-muted small">{{ group.groupCode }}</strong>
                <ul class="list-unstyled ml-3">
                    <li 
                        v-for="feature in group.included" 
                        :key="feature.featureType"
                        class="text-muted small"
                    >
                        <i class="mdi mdi-check text-success mr-1"></i>
                        {{ getFeatureTypeLabel(feature.featureType) }}
                        <span v-if="feature.description" class="text-muted">- {{ feature.description }}</span>
                    </li>
                </ul>
            </div>
        </div>

        <!-- Redeem Information -->
        <div v-if="redeemInfo" class="redeem-info mb-3">
            <h6 class="text-info">
                <i class="mdi mdi-ticket-confirmation mr-2"></i>
                Información de canje
            </h6>
            <div class="redeem-details">
                <p class="text-muted small mb-2">
                    <strong>Tipo:</strong> {{ redeemInfo.type }}
                </p>
                <p class="text-muted small mb-2">
                    <strong>Entrada directa:</strong> 
                    <i v-if="redeemInfo.directEntrance" class="mdi mdi-check text-success"></i>
                    <i v-else class="mdi mdi-close text-muted"></i>
                </p>
                <div v-if="redeemInfo.comments && redeemInfo.comments.length > 0">
                    <strong class="text-muted small">Comentarios:</strong>
                    <ul class="list-unstyled ml-3">
                        <li 
                            v-for="(comment, index) in redeemInfo.comments" 
                            :key="index"
                            class="text-muted small"
                            v-html="comment.description"
                        ></li>
                    </ul>
                </div>
            </div>
        </div>

        <!-- Segmentation Groups -->
        <div v-if="segmentationGroups.length > 0" class="segmentation-groups">
            <h6 class="text-primary">
                <i class="mdi mdi-tag mr-2"></i>
                Categorías y características
            </h6>
            <div class="segmentation-list">
                <div 
                    v-for="group in segmentationGroups" 
                    :key="group.code"
                    class="segmentation-item mb-2"
                >
                    <strong class="text-muted small">{{ group.name }}:</strong>
                    <div class="segments ml-3">
                        <span 
                            v-for="segment in group.segments" 
                            :key="segment.code"
                            class="badge badge-outline-primary mr-1 mb-1"
                            style="font-size: 0.7rem;"
                        >
                            {{ segment.name }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.activity-details {
    border-top: 1px solid #e9ecef;
    padding-top: 1rem;
}

.important-info h6,
.feature-groups h6,
.redeem-info h6,
.segmentation-groups h6 {
    font-size: 0.9rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
}

.segmentation-item {
    margin-bottom: 0.75rem;
}

.badge-outline-primary {
    color: #007bff;
    border: 1px solid #007bff;
    background-color: transparent;
}

.badge-outline-primary:hover {
    background-color: #007bff;
    color: white;
}
</style> 